module.exports = __webpack_public_path__ + "img/pr-10.e03358c4.png";